import { readPreference, writePreference } from "./preferences";

const CLIENT_ID_KEY = "neurondeck-client-id";

let transientClientId: string | undefined;

export const getClientId = (): string => {
  const existing = readPreference(CLIENT_ID_KEY) ?? transientClientId;
  if (existing) return existing;
  const value = crypto.randomUUID().replaceAll("-", "");
  transientClientId = value;
  writePreference(CLIENT_ID_KEY, value);
  return value;
};
